import {Component, OnInit, Inject, ViewChild, ElementRef} from "@angular/core";
import {SuiModal, ComponentModalConfig, ModalSize, SuiModalService} from "@richardlt/ng2-semantic-ui";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {DOCUMENT} from "@angular/common";
import { FinanceService } from 'src/modules/features/contractor/services';

interface IUploadProofOfPaymentModalContext {
	title?: string;
	extraData?: any;
	isEdit: boolean;
	gatewayReferenceId?: string;
}

@Component({
	selector: "app-upload-proof-of-payment-modal",
	templateUrl: "./upload-proof-of-payment-modal.component.html",
	styleUrls: ["./upload-proof-of-payment-modal.component.scss"],
})
export class UploadProofOfPaymentModalComponent implements OnInit {
	@ViewChild('input') input: ElementRef;
	formSubmitAttempt: boolean;
	searchable: boolean = true;

	loading: boolean;

	uploadProofOfPaymentForm: FormGroup = this.fb.group({
		orderId: [""],
		nameOfBank: ["", Validators.required],
		nameOfBankBranch: [""],
		bankCountry: [""],
		tellerNumber: ["", Validators.required],
		payerEmail: ["", Validators.required],
		description: [""],
		payerName: ["", Validators.required],
		file: ["", Validators.required],
		path: [""],
	});
	extraData: any;
	pending: boolean;
	success: any;
	error: any;
	revenueServices;
	fileObj: any;
	gatewayReferenceId;
	selectedRevenueServices = [];

	constructor(
		@Inject(DOCUMENT) private document,
		public modal: SuiModal<IUploadProofOfPaymentModalContext, void, void>,
		private modalService: SuiModalService, 
		private fb: FormBuilder,
		private service: FinanceService,
	) {
		this.gatewayReferenceId = modal.context.gatewayReferenceId;
		//check if edit is set to true when calling the modal
		if (modal.context.isEdit == true) {
			// this.uploadProofOfPaymentForm.patchValue();

			this.extraData = modal.context.extraData;
		}
	}


	isFieldValid(field: string) {
		return (
			(!this.uploadProofOfPaymentForm.get(field).valid && this.uploadProofOfPaymentForm.get(field).touched) ||
			(this.uploadProofOfPaymentForm.get(field).untouched && this.formSubmitAttempt)
		);
	}

	displayFieldCss(field: string) {
		return {
			error: this.isFieldValid(field),
		};
	}

	displayFormCss(field: string) {
		return {
			loading: field,
		};
	}

	nullify() {
		this.error = null;
		this.success = null;
	}

	save() {
		this.nullify();
		this.formSubmitAttempt = false;
		if (this.uploadProofOfPaymentForm.valid) {
			this.pending = true;
			const formData = new FormData();
			this.uploadProofOfPaymentForm.value["orderId"] = this.gatewayReferenceId;
			const blob = new Blob([JSON.stringify(this.uploadProofOfPaymentForm.value)], {
				type: "application/json",
			});
			formData.append("file", this.fileObj);
			formData.append("data", blob);
			this.service.uploadProofOfPayment({
				body: formData
			}).subscribe(
				(res: any) => {
					this.pending = false;
					this.input.nativeElement.focus()
					this.success = "Proof of payment uploaded successfully";
					setTimeout(() => {
						this.uploadProofOfPaymentForm.value['path'] = res['documentPath'];
						this.modal.approve(this.uploadProofOfPaymentForm.value);
					}, 2000);
				},
				(error) => {
					this.pending = false;
					this.error = error.error ? error.error : error;
				}
			);
		} else {
			this.formSubmitAttempt = true;
		}
	}

	onFileSelected(event) {
		console.log('event ', event.target.files);
		this.fileObj = event.target.files.item(0);
	}

	
	ngOnInit() {
		
	}
	
	ngOnDestroy(): void {
		
	}
}

export class UploadProofOfPaymentModal extends ComponentModalConfig<IUploadProofOfPaymentModalContext, void, void> {
	constructor(title, extraData: any, isEdit, gatewayReferenceId: string, size: ModalSize = ModalSize.Tiny) {
		super(UploadProofOfPaymentModalComponent, {title, extraData, isEdit, gatewayReferenceId});

		this.transition = 'slide left';
		this.isClosable = false;
		this.transitionDuration = 200;
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
